<template>
  <modal :is-open="itemDescriptionModalIsOpen"
         :closeable="false">

    <div>
      {{ currentSelectedItem.displayName }}:
      {{ currentSelectedItem.description }}
    </div>

    <div v-if="currentSelectedItem.type === 2">
      <br>
      <div>
        <div style="font-weight: bold;text-decoration: underline;">Catch rate</div>
        {{ currentSelectedItem.catchRate }}
      </div>
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="itemDescriptionModalIsOpen=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>


  <modal :is-open="confirmationModalIsOpen" :closeable="false">
    <!--    <span v-html="translation.shop.purchaseConfirmationMessage(currentSelectedItem.displayName, amount, totalCosts)"></span>-->
    Are you sure that you want to buy <span class="font-weight-bold">{{ amount }}</span>x <span
      class="font-weight-bold">{{ currentSelectedItem.displayName }}</span>
    for a total of <span class="font-weight-bold">
        {{ totalCosts }}
            <img :src="imageUri + 'static/twitchextension/img/balls/battle_coin.svg'" style="width: 6vh;">

  </span>?

    <template #footer>

      <button type="button" class="btn btn-secondary" @click="confirmationModalIsOpen=false;">
        {{ translation.general.cancel }}
      </button>
      <button type="button" class="btn btn-primary" @click="purchaseItem(currentSelectedItem.shopID, amount);">
        {{ translation.shop.purchase }}
      </button>
    </template>
  </modal>


  <br>

  <div style="display: flex;">
    <div style="width:40%;margin:auto;">
      <button @click="enterInventory()" class="back-to-inventory-button" :disabled="isBlocked">
        Inventory
      </button>
    </div>

    <br>

    <div style="width:40%;margin:auto;">
      <button @click="enterShop()" class="back-to-inventory-button" :disabled="isBlocked">
        Shop
      </button>
    </div>
  </div>


  <div class="container">

    <h5 class="item-list__title">
      You have: {{ cash }} <img :src="imageUri + 'static/twitchextension/img/balls/battle_coin.svg'"
                                style="width: 6vh;"><br>
      <h6>Shop rotation in: {{ nextRotation }}</h6>
    </h5>
  </div>

  <div
      v-for="(item, i) in shopItems"
      :key="item">

    <div style="display: flex;height:70px;border-radius: 15px;width:90%;margin:auto;"
         :style="[i % 2 ? {backgroundColor: '#707070'} : {backgroundColor: '#494949'}]">

      <div style="margin-top: 9px;">
        <div style="position: absolute;left: 10%;">
          <div style="padding: 15px;" v-if="!item.sprite_name">

            <ItemEntryButton :id="1" :name="''" :sprite_name="item.name" :amount="0"
                             @click="itemPictureClicked(item);"/>
          </div>
          <div v-else style="position: absolute;left: 15px;">
            <PokemonEntryButton

                :pokedex-id="item.id"
                :id="1" :name="''"
                :is-shiny="false" :sell-price="0"
                :lvl="'?'" :hpPercent="null" :is-buddy="false"
                @click="itemPictureClicked(item);"
            />
          </div>
        </div>
      </div>

      <div style="width:23%;">

      </div>
      <div style="width:20%;margin:auto;color:white;">
        {{ item.displayName }}
      </div>

      <div style="width: 15%;color:white;margin:auto;">
        {{ item.price }}
        <img :src="imageUri + 'static/twitchextension/img/balls/battle_coin.svg'" style="width: 6vh;">
      </div>
      <button class="purchase-button" @click="itemClicked(item);">
        {{ translation.shop.purchase }}
      </button>

    </div>
    <br>
  </div>

</template>

<script>
import {currentView} from "../../utils/globals";
import ItemList from "./ItemList";
import ItemEntryButton from "../../components/ItemEntryButton/ItemEntryButton";
import Modal from "@/components/Modal/Modal";
import {ref} from "@vue/reactivity";
import {translation} from "@/utils/translations";
import {startLoadingProcess, stopLoadingProcess} from "../../components/LoadingOverlay/loadingOverlayControl";
import axios from "axios";
import {backendUri, imageUri} from "../../utils/settings";
import {handleUnknownError} from "../../utils/utilities";
import {onMounted} from "@vue/runtime-core";
import {blockButton, isBlocked, unblockButton} from "../../components/ButtonControl/ButtonControl";
import {showModalMsg} from "../../components/Modal/modalUtils";
import PokemonEntryButton from "../../components/PokemonEntryButton/PokemonEntryButton";
import ItemShop from "./ItemShop";

export default {
  name: "ItemShop",
  components: {
    ItemEntryButton, Modal, PokemonEntryButton
  },
  data() {
    return {
      amount: 1
    }
  },
  setup() {
    const shopItems = ref({});
    const itemDescriptionModalIsOpen = ref(false);
    const confirmationModalIsOpen = ref(false);
    const currentSelectedItem = ref({});
    const nextRotation = ref({});

    const totalCosts = ref(0);
    const cash = ref([]);

    const calcTotalCosts = async (amount) => {
      totalCosts.value = currentSelectedItem.value.price * amount;
    }

    const itemClicked = async (item) => {
      currentSelectedItem.value = item;
      confirmationModalIsOpen.value = true;
      await calcTotalCosts(1);
    }
    const itemPictureClicked = async (item) => {
      currentSelectedItem.value = item;
      itemDescriptionModalIsOpen.value = true;
    }


    const enterInventory = async () => {
      blockButton();
      currentView.value = ItemList;
    }

    const enterShop = async () => {
      blockButton();
      currentView.value = ItemShop;
    }

    const purchaseItem = async (shopID, amount) => {
      confirmationModalIsOpen.value = false;

      await axios.post(backendUri + "api/game/ext/battle-coin-shop/purchase/", {shopID: shopID, amount: amount})
          .then(resp => {
            cash.value = resp.data.cash
            showModalMsg(translation.shop.purchaseSuccessfully);
          })
          .catch(error => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.shop.itemDoesNotExist);
            } else if (error.response.data.error === 50) {
              showModalMsg(translation.shop.itemAmountLessThenZero);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.shop.itemNotPurchasable);
            } else if (error.response.data.error === 3) {
              showModalMsg(translation.shop.notEnoughBattleCoinsToBuy);
            } else {
              handleUnknownError(error);
            }
          })
    }

    const refreshView = async () => {
      startLoadingProcess();
      await axios.get(backendUri + "api/game/ext/battle-coin-shop/")
          .then((resp) => {
            shopItems.value = resp.data.shopItems;
            cash.value = resp.data.cash
            nextRotation.value = resp.data.nextRotation;
          })
          .catch(error => {
            handleUnknownError(error);
          })
      stopLoadingProcess();
    }

    onMounted(() => {
      refreshView();
      setTimeout(function () {
        unblockButton();
      }, 3000);
    });

    return {
      enterInventory,
      currentSelectedItem,
      translation,
      itemClicked,
      calcTotalCosts,
      totalCosts,
      confirmationModalIsOpen,
      itemDescriptionModalIsOpen,
      itemPictureClicked,
      refreshView,
      shopItems,
      purchaseItem,
      isBlocked,
      cash,
      imageUri,
      enterShop,
      nextRotation
    }
  }
}
</script>

<style lang="scss">

.back-to-inventory-button {
  width: 100%;
  margin: auto;
  border-radius: 55px;
  background-color: #007bff;
  border-color: black;
  color: white;

  &:disabled {
    opacity: 0.2;
  }

  &:hover {
    transform: scale(1.1);
  }
}


.purchase-button {
  width: 30%;
  height: 30px;
  margin: auto;
  border-radius: 55px;
  border: none;

  &:hover {
    transform: scale(1.1);
  }

}

.item-list {
  &__title {
    padding-top: 20px;
    margin-left: 8px;
  }

  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>